export function isPhone(): boolean {
  return matchMedia('(any-pointer: coarse)').matches && Math.min(screen.width, screen.height) < 600;
}
export function customDimensions(rows: number, columns: number, phone: boolean): { rows: number; columns: number } {
  const clamp = (value: number, low: number, high: number, fallback: number) => Math.max(low, Math.min(high, Math.trunc(Number.isFinite(value) ? value : fallback)));
  return { rows: clamp(rows, phone ? 8 : 3, phone ? 16 : 32, 11), columns: clamp(columns, phone ? 5 : 3, phone ? 8 : 24, phone ? 8 : 9) };
}
export async function lockPhonePortrait(fullscreen = false): Promise<void> {
  if (!isPhone()) return;
  const orientation = screen.orientation as ScreenOrientation & { lock?: (orientation: string) => Promise<void> };
  if (fullscreen && document.fullscreenEnabled && !document.fullscreenElement) {
    try { await document.documentElement.requestFullscreen({ navigationUI: 'hide' }); } catch { /* Focus layout still works. */ }
  }
  try { await orientation?.lock?.('portrait'); } catch { /* Browser tabs may deny lock; narrow layout remains. */ }
}
